import {possibleEvaluationsAnswers, possibleQuestionAnswers, questions} from "@constants/common";


function detectQuestionIcon(answer, childIcon) {
    if (!answer && !childIcon) return '';

    if (answer === possibleQuestionAnswers.no) {
        return 'e-icon-assessment-question-no-outline';
    }
    if (!childIcon) {
        return 'e-icon-assessment-question-no'
    }
    return childIcon;
}

function iconsPriority(icons) {
    if (icons.includes('e-icon-effectiveness-no')) {
        return 'e-icon-effectiveness-no'

    } else if (icons.includes('e-icon-effectiveness-inprogress')) {
        return 'e-icon-effectiveness-inprogress'

    } else if (icons.includes('e-icon-effectiveness-yes')) {
        return 'e-icon-effectiveness-yes'

    } else if (icons.includes('e-icon-assessment-question-no-outline')) {
        return 'e-icon-assessment-question-no-outline'

    } else if (icons.includes('e-icon-assessment-question-no')) {
        return 'e-icon-assessment-question-no'
    }
}

function evaluationIcon(answer) {
    switch (answer) {
        case possibleEvaluationsAnswers.no: {
            return 'e-icon-effectiveness-no'
        }
        case possibleEvaluationsAnswers.maybe: {
            return 'e-icon-effectiveness-inprogress'
        }
        case possibleEvaluationsAnswers.yes: {
            return 'e-icon-effectiveness-yes'
        }
        default:
            return ''
    }
}

function questionIcon(answerObject) {
    let currentAnswer = answerObject.answer;
    let currentType = answerObject.type;
        switch (currentType) {
            case questions.types.evaluation: {
                return evaluationIcon(currentAnswer)
            }
            case questions.types.option:
            case questions.types.section:
            case questions.types.options:
            case questions.types.question: {
                const icons = [];
                const children = answerObject.children.flat(2);
                for (let i = 0; i < children.length; i++) {
                    icons.push(questionIcon(children[i]))
                }
                const childrenIcon = iconsPriority(icons);
                return detectQuestionIcon(currentAnswer, childrenIcon);
            }
            default : {
                return ''
            }
        }
    }

let assessment = {
    computed: {
        assessmentHelper() {
            return {
                sectionIcon: function (sectionsIcons) {
                    return iconsPriority(sectionsIcons);
                },
                questionIcon: function (questionAnswers) {
                    return questionIcon(questionAnswers)
                }
            }
        }
    }

}

export default assessment
